// extracted by mini-css-extract-plugin
module.exports = {"search":"ConnectedSearchBar_search__11I75"};